import React, { useState } from "react";
import DataTable from "../../components/table/data-table";
import { InviteModal, SuccessModal } from "../../components/modal";
import { useNavigate } from "react-router-dom";
import PageIntroNav from "../../components/navigation/PageIntroNav";

const Company = () => {
  const [openpositionModal, setOpenPositionModal] = useState(false);
  const [opensucesssModal, setOpensuccessModal] = useState(false);

  const openModal = () => setOpenPositionModal(true);
  const createHandleSuccess = (ev) => {
    ev.preventDefault();
    setOpenPositionModal(false);
    setOpensuccessModal(true);
  };

  let navigate = useNavigate();
  const company = [
    {
      name: "Cephas ICT HUB",
      days: "15days",
      department: "Product Design",
      description: "Lorem dolor sit amet lorem",
    },
    {
      name: "Cephas ICT HUB",
      days: "15days",

      department: "Product Design",
      description: "Lorem dolor sit amet lorem ",
    },
    {
      name: "Cephas ICT HUB",
      days: "15days",
      department: "Product Design",
      description: "Lorem dolor sit amet lorem",
    },
    {
      name: "Cephas ICT HUB",
      days: "15days",
      department: "Product Design",
      description: "Lorem dolor sit amet lorem",
    },
    {
      name: "Cephas ICT HUB",
      days: "15days",
      department: "Product Design",
      description: "Lorem dolor sit amet lorem",
    },
    {
      name: "Cephas ICT HUB",
      days: "15days",
      department: "Product Design",
      description: "Lorem dolor sit amet lorem",
    },
    {
      name: "Cephas ICT HUB",
      days: "15days",
      department: "Product Design",
      description: "Lorem dolor sit amet lorem",
    },
    {
      name: "Cephas ICT HUB",
      days: "15days",
      department: "Product Design",
      description: "Lorem dolor sit amet lorem",
    },
    {
      name: "Cephas ICT HUB",
      days: "15days",
      department: "Product Design",
      description: "Lorem dolor sit amet lorem",
    },
    {
      name: "Cephas ICT HUB",
      days: "15days",
      department: "Product Design",
      description: "Lorem dolor sit amet lorem",
    },
    {
      name: "Cephas ICT HUB",
      days: "15days",
      department: "Product Design",
      description: "Lorem dolor sit amet lorem",
    },
    {
      name: "Cephas ICT HUB",
      days: "15days",
      department: "Product Design",
      description: "Lorem dolor sit amet lorem",
    },
  ];

  const headings = ["Company Name", "Description", "Actions"];
  const columns = ["name", "description"];
  return (
    <div>
      <PageIntroNav
        breadcrumbs={[
          { label: "Company Settings", path: "/company-settings" },
          { label: "Company" },
        ]}
        title="All Positions"
        fallbackPath="/company-settings"
        backLabel="Back to Company Settings"
        actions={(
          <button
            onClick={openModal}
            className="bg-[#1234CD] px-6 py-2 rounded-xl text-white"
          >
            Add new
          </button>
        )}
      />

      <DataTable
        title=""
        headings={headings}
        columns={columns}
        data={company}
        onView={(row) => navigate("/company-settings/companyview-details")}
      />

      <InviteModal
        isOpen={openpositionModal}
        onClose={() => setOpenPositionModal(false)}
      >
        <div className="my-8">
          <div>
            <p className=" text-2xl font-semibold text-black font-Outfit">
              Add Company
            </p>
          </div>
          <form
            className="my-12"
            onSubmit={createHandleSuccess}
          >
            <div>
              <label
                htmlFor="invite-email"
                className="block mb-2 font-[500] text-[14px] text-black leading-[18.9px] font-satosh"
              >
                Company Name
              </label>
              <input
                type="text"
                id="text"
                placeholder="Title"
                // value={inviteEmail}
                // onChange={(ev) => setInviteEmail(ev.target.value)}
                className="w-full p-2 text-center mb-2  rounded-xl focus:outline-[#1234CD] border-2 border-[#F3F5F5] py-[16px]"
              />
            </div>

            <div>
              <label
                htmlFor="invite-email"
                className="block mb-2 font-[500] text-[14px] text-black leading-[18.9px] font-satosh"
              >
                Company Website
              </label>
              <input
                type="text"
                id="text"
                placeholder="Title"
                // value={inviteEmail}
                // onChange={(ev) => setInviteEmail(ev.target.value)}
                className="w-full p-2 text-center mb-2  rounded-xl focus:outline-[#1234CD] border-2 border-[#F3F5F5] py-[16px]"
              />
            </div>

            <div className=" flex justify-center mt-10 items-end">
              <button
                type="submit"
                s
                className="font-[700] font-satoshi  leading-[21.6px] w-40 rounded-xl text-white py-[16px] bg-[#1234CD]  h-[40px]text-[16px] "
              >
                <span>Create</span>
              </button>
            </div>
          </form>
        </div>
      </InviteModal>

      <SuccessModal
        isOpen={opensucesssModal}
        onClose={() => setOpensuccessModal(false)}
      />
    </div>
  );
};

export default Company;
